import './applianceDetailsMadeIn.scss';

import { IProductPrice } from '@progymedia/gatsby-theme-boutik-ecommerce/src/engine/PricesAndInventoriesCache';
import React from 'react';

import usaFlag from '../../images/icons/usa.png';
import canadaFlag from '../../images/icons/canada.png';
import { useTranslation } from 'react-i18next';

export default function ApplianceDetailsMadeIn(props: {
    price: IProductPrice | undefined;
}) {
    const { t } = useTranslation('layout');

    return (
        <div className='made-in-container'>
            <>
                {props?.price?.madeIn?.isMadeInUSA && (
                    <div className='made-in-usa'>
                        <img className='made-in-flag' src={usaFlag} alt='' />
                        <span className='made-in-text'>
                            {t('appliance.usa')}
                        </span>
                    </div>
                )}
                {props?.price?.madeIn?.isMadeInCanada && (
                    <div className='made-in-canada'>
                        <img className='made-in-flag' src={canadaFlag} alt='' />
                        <span className='made-in-text'>
                            {t('appliance.canada')}
                        </span>
                    </div>
                )}
            </>
        </div>
    );
}
